import { render, staticRenderFns } from "./devices_data.vue?vue&type=template&id=1724b1a8"
import script from "./devices_data.vue?vue&type=script&lang=js"
export * from "./devices_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports